import React, { useState } from "react";

import AdminHeaderBar from "@components/AdminHeaderBar";
import AdminHeaderMenu from "@components/AdminHeaderMenu";

function AdminHeader() {
  const [activeMenu, setActiveMenu] = useState(false);

  function handleToggleActiveMenu(active) {
    setActiveMenu(active);
  }

  function handleInactiveMenu() {
    setActiveMenu(false);
  }

  return (
    <header>
      <AdminHeaderBar
        activeMenu={activeMenu}
        onToggleMenu={handleToggleActiveMenu}
      />
      <AdminHeaderMenu
        activeMenu={activeMenu}
        onInactiveMenu={handleInactiveMenu}
      />
    </header>
  );
}

export default AdminHeader;
